import { makeAutoObservable } from "mobx";
import { DataTableStore } from "./DataTableStore";
import { onError } from "@/utils/onError";
import { FiltersStore } from "./FiltersStore";
import { SearchFilter } from "@/components/filters";
export class ChargingStationModelsStore {
    constructor(chargingStationModelService) {
        this.chargingStationModelService = chargingStationModelService;
        this.loading = false;
        this.initializeChargingStationModelFilters = () => {
            const filterItems = [
                // Search Filter
                {
                    id: "search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по названию, производителю...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.filtersStore.updateFilter("search", value),
                    },
                    visible: true,
                    order: 4,
                },
            ];
            this.filtersStore.setFilterItems(filterItems);
        };
        this.dataTable = new DataTableStore({
            defaultFilters: { search: "" },
            dataLoader: {
                loadData: (params) => this.loadModels(params),
            },
        });
        this.filtersStore = new FiltersStore();
        this.initializeChargingStationModelFilters();
        makeAutoObservable(this);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async loadModels(params) {
        try {
            const result = await this.chargingStationModelService.getModelsWithParams({
                page: params.page,
                pageSize: params.pageSize,
                filters: params.filters,
                sorters: params.sorters,
            });
            return {
                data: result.data,
                total: result.total,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            throw error;
        }
    }
    async deleteModel(id) {
        this.setLoading(true);
        try {
            await this.chargingStationModelService.deleteModel(id);
            await this.dataTable.refresh();
        }
        catch (error) {
            onError(error, "Error deleting charging station model");
        }
        finally {
            this.setLoading(false);
        }
    }
}
